import React from 'react';

const NoResults = () => (
  <div className="empty-results">No results found.</div>
);

export default NoResults;
